/**
 * Created by jahidul.hasan on 9/8/2019.
 */
import {Action} from '@ngrx/store';
import {
  DeleteFieldQuestionCommand, DeleteSurveyCommand,
  DeleteSurveySectionCommand, SurveyTemplateExportCommand
} from '../../commands/survey.commands';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';

export const GET_SURVEY = '[Surveys] GET_SURVEY';
export const GET_SURVEY_SUCCESS = '[Surveys] GET_SURVEY_SUCCESS';
export const GET_SURVEY_FAILED = '[Surveys] GET_SURVEY_FAILED';
export const DELETE_SURVEY = '[Surveys] DELETE_SURVEY';
export const DELETE_SURVEY_SUCCESS = '[Surveys] DELETE_SURVEY_SUCCESS';
export const DELETE_SURVEY_FAILED = '[Surveys] DELETE_SURVEY_FAILED';
export const DELETE_SURVEY_SECTION = '[Surveys] DELETE_SURVEY_SECTION';
export const DELETE_SURVEY_SECTION_SUCCESS = '[Surveys] DELETE_SURVEY_SECTION_SUCCESS';
export const DELETE_SURVEY_SECTION_FAILED = '[Surveys] DELETE_SURVEY_SECTION_FAILED';
export const DELETE_FIELD_QUESTION = '[Surveys] DELETE_FIELD_QUESTION';
export const DELETE_FIELD_QUESTION_SUCCESS = '[Surveys] DELETE_FIELD_QUESTION_SUCCESS';
export const DELETE_FIELD_QUESTION_FAILED = '[Surveys] DELETE_FIELD_QUESTION_FAILED';
export const SURVEY_TEMPLATE_EXPORT = '[Surveys] SURVEY_TEMPLATE_EXPORT';

export class GetSurveyAction implements Action {
  readonly type = GET_SURVEY;

  constructor(public surveyId: string) {
  }
}

export class GetSurveySuccessAction implements Action {
  readonly type = GET_SURVEY_SUCCESS;

  constructor(public survey: any) {
  }
}

export class GetSurveyFailedAction implements Action {
  readonly type = GET_SURVEY_FAILED;

  constructor(public error: any) {
  }
}
export class DeleteSurveyAction implements Action {
  readonly type = DELETE_SURVEY;

  constructor(public deleteSurveyCommand: DeleteSurveyCommand, public invalidateSubject: InvalidateSubject) {
  }
}

export class DeleteSurveySuccessAction implements Action {
  readonly type = DELETE_SURVEY_SUCCESS;

  constructor(public invalidateSubject: InvalidateSubject) {
  }
}

export class DeleteSurveyFailedAction implements Action {
  readonly type = DELETE_SURVEY_FAILED;

  constructor(public error: any) {
  }
}

export class DeleteSurveySectionAction implements Action {
  readonly type = DELETE_SURVEY_SECTION;

  constructor(public deleteSurveySectionCommand: DeleteSurveySectionCommand) {
  }
}

export class DeleteSurveySectionSuccessAction implements Action {
  readonly type = DELETE_SURVEY_SECTION_SUCCESS;

  constructor(payload: any) {
  }
}

export class DeleteSurveySectionFailedAction implements Action {
  readonly type = DELETE_SURVEY_SECTION_FAILED;

  constructor(public error: any) {
  }
}

export class DeleteFieldQuestionAction implements Action {
  readonly type = DELETE_FIELD_QUESTION;

  constructor(public deleteFieldQuestionCommand: DeleteFieldQuestionCommand) {
  }
}

export class DeleteFieldQuestionSuccessAction implements Action {
  readonly type = DELETE_FIELD_QUESTION_SUCCESS;

  constructor(public payload: any) {
  }
}

export class DeleteFieldQuestionFailedAction implements Action {
  readonly type = DELETE_FIELD_QUESTION_FAILED;

  constructor(public error: any) {
  }
}


export type DataSurveyActions = GetSurveyAction
| GetSurveySuccessAction
| GetSurveyFailedAction
| DeleteSurveyAction
| DeleteSurveySuccessAction
| DeleteSurveyFailedAction
| DeleteSurveySectionAction
| DeleteSurveySectionSuccessAction
| DeleteSurveySectionFailedAction
| DeleteFieldQuestionAction
| DeleteFieldQuestionSuccessAction
| DeleteFieldQuestionFailedAction;
